import React from "react";
import DashboardTranslationsMonthly from "./DashboardTranslationsMonthly";

const DashboardV2TranslationsMonthly = ({ user, dateSelection }) => (
  <DashboardTranslationsMonthly user={user} dateSelection={dateSelection} />
);

export default DashboardV2TranslationsMonthly;
